import { render } from "./HomePageTwo.vue?vue&type=template&id=5f9a32f7"
import script from "./HomePageTwo.vue?vue&type=script&lang=js"
export * from "./HomePageTwo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__